import React from 'react';

function getBrandColor(brand) {
  const colors = {
    'BRANCA': '#999',
    'VIBRA': '#00a651',
    'RAIZEN': '#ffc107',
    'IPIRANGA': '#ff6600',
    'ALE': '#0066cc',
    'TOTALENERGIES': '#e4002b',
    'CHARRUA': '#8b4513',
    'LARCO': '#6f42c1',
  };
  return colors[brand] || '#666';
}

export default function StationList({ stations, loading, selectedStation, onStationClick }) {
  if (loading) {
    return (
      <div className="station-list">
        <div className="loading-spinner">Buscando postos próximos...</div>
      </div>
    );
  }

  if (!stations.length) {
    return (
      <div className="station-list">
        <p className="no-results">
          Nenhum posto encontrado nesta área. Tente aumentar o raio de busca.
        </p>
      </div>
    );
  }

  const handleClick = (station) => {
    if (onStationClick) onStationClick(station);
    // Scroll to map on mobile
    const mapEl = document.querySelector('.map-section');
    if (mapEl && window.innerWidth <= 900) {
      mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="station-list">
      <h3>Postos Próximos ({stations.length})</h3>
      <div className="stations-scroll">
        {stations.map((station) => (
          <div
            key={station.id}
            className={`station-card ${selectedStation && selectedStation.id === station.id ? 'station-card-selected' : ''}`}
            onClick={() => handleClick(station)}
          >
            <div className="station-header">
              <span className="station-name">{station.station_name}</span>
              <span className="station-price">
                R$ {station.sale_price.toFixed(2)}
              </span>
            </div>
            <div className="station-details">
              <span className="station-product">{station.product}</span>
              <span
                className="station-brand"
                style={{ borderColor: getBrandColor(station.brand) }}
              >
                {station.brand}
              </span>
            </div>
            <div className="station-address">
              {station.address && `${station.address}, `}{station.neighborhood}
              <br />
              {station.municipality} - {station.state}
            </div>
            <div className="station-footer">
              <span className="station-distance">{station.distance_km} km</span>
              <span className="station-date">
                Atualizado: {new Date(station.collection_date).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
